import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBar = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const cookieConsent = localStorage.getItem('cookieConsent');
		if (!cookieConsent) {
			setIsVisible(true);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem('cookieConsent', 'true');
		setIsVisible(false);
	};

	if (!isVisible) {
		return null;
	}

	return (
		<div className="fixed bottom-0 w-full bg-gray-800 text-white text-center p-4 z-50">
			<p className="inline">
				We use essential cookies to ensure that we give you the best experience on our website. By continuing to
				use this site, you consent to the use of these cookies.{' '}
				<Link to="/dsgvo" className="cursor-pointer underline">
					Read more
				</Link>
			</p>
			<button
				onClick={handleAccept}
				className="ml-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
			>
				Accept
			</button>
		</div>
	);
};

export default CookieBar;
